import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';

const TransitionContainer = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  pointer-events: none;
`;

const Overlay = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
`;

const PageTransition = ({ children }) => {
  const location = useLocation();
  
  // On garde les transitions pour toutes les pages, y compris la page d'accueil
  const overlayVariants = {
    initial: {
      height: '100%',
      bottom: 0,
    },
    animate: {
      height: 0,
      bottom: 0, // Le rideau se retire par le bas
      transition: {
        duration: 0.6,
        ease: [0.43, 0.13, 0.23, 0.96]
      }
    },
    exit: {
      height: '100%',
      bottom: 0, // Le rideau monte par le bas
      transition: {
        duration: 0.6,
        ease: [0.43, 0.13, 0.23, 0.96]
      }
    }
  };

  return (
    <>
      <TransitionContainer
        initial="initial"
        animate="animate"
        exit="exit"
      >
        <Overlay variants={overlayVariants} />
      </TransitionContainer>
      {children}
    </>
  );
};

export default PageTransition;